import React, { useEffect, useState } from "react";
import useApi from "../utils/useApi";

import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "../css/User.css";
import { Autocomplete, TextField } from "@mui/material";
import ic_clone from "../img/ic_clone.png";
import { data } from "react-router-dom";
import "../css/VoucherNumberSettingsTab.css";
import { Save } from "lucide-react";

function GroupLevelFormPopup(props) {
  const COMPANY_CODE = localStorage.getItem("companyCode");
  const [loadingForSaving, setLoadingForSaving] = useState(false);
  // const COMPANY_CODE = localStorage.getItem("companyCode") || "-";

  const {
    setShowGroupLevelForm,
    selectedGroup,
    successfullyDone,
    accToEdit,
    setAccToEdit,
  } = props;

  const {
    data: datagetDuplicateCheckOnAcc,
    loading: loadinggetDuplicateCheckOnAcc,
    error: errorgetDuplicateCheckOnAcc,
    get: getDuplicateCheckOnAcc,
  } = useApi();

  const {
    data: datagetDuplicateCheckOnAccSubmit,
    loading: loadinggetDuplicateCheckOnAccSubmit,
    error: errorgetDuplicateCheckOnAccSubmit,
    get: getDuplicateCheckOnAccSubmit,
  } = useApi();

  const [
    selectedEmployeeObjectFromAutoComplete,
    setSelectedEmployeeObjectFromAutoComplete,
  ] = useState(null);
  const [
    selectedEmployeeObjectFromAutoCompleteTo,
    setSelectedEmployeeObjectFromAutoCompleteTo,
  ] = useState(null);

  const {
    data: getData,
    loading: getLoading,
    error: getError,
    get: getUsers,
  } = useApi();
  const {
    data: dataPostClone,
    loading: loadingPostClone,
    error: errorPostClone,
    post: postClone,
  } = useApi();

  const {
    data: datagetAcTypeNewNum,
    loading: loadinggetAcTypeNewNum,
    error: errorgetAcTypeNewNum,
    get: getAcTypeNewNum,
  } = useApi();

  const initialAccNumberArray = ["0", "0", "0", "0"];

  const [accNumberArray, setAccNumberArray] = useState(initialAccNumberArray);

  const [accGroupDescription, setAccGroupDescription] = useState("");
  const [accCTPercentage, setAccCTPercentage] = useState("0");

  const checkIfDuplicateAccNumber = (accNumberArrayPassed) => {
    let numberToCheck = accNumberArrayPassed.map((item) => item).join("");
    getDuplicateCheckOnAcc(
      `https://cubixweberp.com:213/api/CRMGLSettings/${COMPANY_CODE}/ACTYPECOUNT/${numberToCheck}/-/-/-`
    );
  };

  useEffect(() => {
    if (datagetDuplicateCheckOnAcc) {
      console.log("response of check duplicate", datagetDuplicateCheckOnAcc);

      if (datagetDuplicateCheckOnAcc[0]?.Column1 === 1) {
        alert("Account Number already exists");
        return;
      }
    }
  }, [datagetDuplicateCheckOnAcc]);

  const handleAccNumberChange = (e, indexOfTyped) => {
    console.log("e, indexOfTyped ", e, indexOfTyped);

    let newArray = accNumberArray?.map((item, index) => {
      if (indexOfTyped === index) {
        if (e.target.value > 9 || e.target.value < 0) {
          return item;
        } else {
          return e.target.value;
        }
      } else {
        return item;
      }
    });

    setAccNumberArray(newArray);
  };

  useEffect(() => {
    if (accNumberArray) {
      if (!accToEdit) {
        checkIfDuplicateAccNumber(accNumberArray);
      }
    }
  }, [accNumberArray]);

  useEffect(() => {
    if (datagetAcTypeNewNum) {
      setAccNumberArray(datagetAcTypeNewNum[0].Column1.split(""));
    }
  }, [datagetAcTypeNewNum]);

  useEffect(() => {
    if (accToEdit) {
      setAccNumberArray(accToEdit?.TYPE?.trim().split(""));
      setAccGroupDescription(accToEdit.DESCRIPTION);
      setAccCTPercentage(accToEdit?.CT_Perc ? accToEdit?.CT_Perc : "0");
    }
  }, [accToEdit]);

  useEffect(() => {
    console.log("useEffect on []");
    getAcTypeNewNum(
      `https://cubixweberp.com:213/api/CRMGLSettings/${COMPANY_CODE}/ACTYPENEWNUM/${selectedGroup.id}/-/-/-`
    );
    getUsers(
      `https://cubixweberp.com:213/api/CpaysCount/${COMPANY_CODE}/USERLIST/-/-`
    );
  }, []);

  const callAPI = (modeTopass) => {
    let numberToCheck = accNumberArray.map((item) => item).join("");

    if (accToEdit) {
      modeTopass = "M";
      numberToCheck = accToEdit.TYPE;
    }

    if (accGroupDescription?.trim()?.length === 0) {
      alert("Please enter description");
      return;
    }

    if (accCTPercentage?.trim()?.length === 0) {
      alert("Please enter Corporate Tax allowable deduction percentage");
      return;
    }

    setLoadingForSaving(true);

    getDuplicateCheckOnAccSubmit(
      `https://cubixweberp.com:213/api/CRMGLSettings/${COMPANY_CODE}/ACTYPECOUNT/${numberToCheck}/-/-/-`
    )
      .then((res) => {
        console.log("res ==", res.data);

        if (res.data[0]?.Column1 != 1) {
          let arraytoPass = [
            {
              CmpCode: COMPANY_CODE,
              mode: modeTopass,
              ACCTYPE: accNumberArray.map((item) => item).join(""),
              GROUPDES: accGroupDescription,
              GROUP: "-",
              SGROUP: "-",
              CTPERC: accCTPercentage,
            },
          ];

          let serialize = JSON.stringify(arraytoPass);

          console.log("arraytoPass>>. ", arraytoPass);

          postClone(`https://cubixweberp.com:213/api/CRMGLTypeReg`, serialize, {
            headers: {
              "Content-Type": "application/json",
            },
          });
        } else if (res.data[0]?.Column1 === 1 && accToEdit) {
          let arraytoPass = [
            {
              CmpCode: COMPANY_CODE,
              mode: modeTopass,
              ACCTYPE: numberToCheck,
              GROUPDES: accGroupDescription,
              GROUP: "-",
              SGROUP: "-",
              CTPERC: accCTPercentage,
            },
          ];

          let serialize = JSON.stringify(arraytoPass);

          console.log("arraytoPass>>. ", arraytoPass);

          postClone(`https://cubixweberp.com:213/api/CRMGLTypeReg`, serialize, {
            headers: {
              "Content-Type": "application/json",
            },
          });
        } else {
          setLoadingForSaving(false);
          alert("Account Number already exists");
        }
      })
      .catch((err) => {
        setLoadingForSaving(false);
      });
  };

  useEffect(() => {
    if (dataPostClone) {
      setLoadingForSaving(false);

      if (dataPostClone?.result?.trim()?.toUpperCase() === "SAVED") {
        setAccNumberArray(initialAccNumberArray);
        setAccGroupDescription("");
        setAccCTPercentage("0");
        setShowGroupLevelForm(false);
        successfullyDone();
      }
    }
  }, [dataPostClone]);

  const cancelledPopup = () => {
    console.log("cancelledPopup ", initialAccNumberArray);
    setShowGroupLevelForm((prev) => !prev);
    setAccNumberArray(initialAccNumberArray);
    setAccGroupDescription("");
    setAccCTPercentage("0");
    setAccToEdit(null);
  };

  return (
    <div className="bg-white">
      <style>{`
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
        input[type=number] { -moz-appearance: textfield; }
      `}</style>

      <div className="p-5 space-y-5">
        {/* Row 1: Account Code Blocks */}
        <div>
          <label className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest block mb-2">
            Account Group Code
          </label>
          <div className="flex gap-1">
            {accToEdit
              ? accToEdit.TYPE?.trim()
                  .split("")
                  .map((item, index) => (
                    <div
                      key={index}
                      className={`w-8 h-9 flex items-center justify-center border rounded font-mono font-semibold ${
                        index === 0
                          ? "bg-slate-800 text-white border-slate-800"
                          : "bg-white text-slate-600 border-slate-200"
                      }`}
                    >
                      {item}
                    </div>
                  ))
              : accNumberArray?.map((item, index) => (
                  <input
                    key={index}
                    type="number"
                    min="0"
                    max="9"
                    disabled={index === 0}
                    value={accNumberArray[index]}
                    onChange={(e) => handleAccNumberChange(e, index)}
                    className={`w-8 h-9 text-center border rounded font-mono font-semibold outline-none ${
                      index === 0
                        ? "bg-slate-800 text-white border-slate-800"
                        : "bg-white border-slate-300 focus:border-[#009688]"
                    }`}
                  />
                ))}
          </div>
        </div>

        {/* Row 2: Description & Tax Deduction */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex-1">
            <label className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest block mb-1">
              Group Description <span className="text-red-500">*</span>
            </label>
            <input
              onChange={(e) => setAccGroupDescription(e.target.value)}
              value={accGroupDescription}
              placeholder="Enter group name..."
              className="w-full border border-slate-200 rounded px-3 h-9 text-sm focus:border-[#009688] outline-none bg-white font-medium"
            />
          </div>

          <div className="flex-1">
            <label className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest block mb-1">
              CT Allowable Deduction (%)
            </label>
            <div className="relative">
              <input
                type="number"
                onChange={(e) => setAccCTPercentage(e.target.value)}
                value={accCTPercentage}
                placeholder="0"
                className="w-full border border-slate-200 rounded px-3 h-9 text-sm focus:border-[#009688] outline-none bg-white font-medium"
              />
              <span className="absolute right-3 top-2 text-xs text-slate-400">
                %
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Section */}
      <div className="bg-slate-100 px-5 py-3 border-t border-slate-200 flex justify-end items-center gap-2">
        <button
          className="px-4 py-1.5 text-sm text-slate-500 hover:text-slate-800 font-semibold transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            cancelledPopup();
          }}
        >
          Cancel
        </button>

        <button
          disabled={loadingForSaving}
          className="flex items-center gap-2 px-6 py-1.5 rounded bg-[#009688] text-white hover:bg-[#00796b] text-sm font-semibold shadow-sm transition-all disabled:opacity-70"
          onClick={() => callAPI("I")}
        >
          {loadingForSaving ? (
            <span className="animate-pulse">Saving...</span>
          ) : (
            <>
              <Save className="w-4 h-4" /> Save Group
            </>
          )}
        </button>
      </div>
    </div>
  );
}

export default GroupLevelFormPopup;
